<div class="toast show" role="alert" [style.display]="state.value === 'inactive' ? 'none' : ''">
  <div class="toast-header">
    <span class="toast-icon"></span>
    <strong class="me-auto" [innerHTML]="title  | keepHtml"></strong>
    <button type="button" class="btn-close" aria-label="Close" (click)="removeToast($event)" *ngIf="options.closeButton"></button>
  </div>
  <div class="toast-body">
    <div [class]="options.messageClass" [innerHTML]="message  | keepHtml"></div>
  </div>
</div>
